module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Add link","input-1":"Insert url","add":"Add"},"pt-BR":{"title":"Adicionar link","input-1":"Insira a url","add":"Adicionar"}}')
  delete Component.options._Ctor
}
